import { KeyValueModel } from "model";
import { EnumTpStatusSessao } from "model/enums/enum-tp-status-sessao";

export const StatusSessaoGerenciamentoMock: KeyValueModel[] = [
    new KeyValueModel(-1, "Todos"),
    new KeyValueModel(EnumTpStatusSessao.Aberta, "Aberta"),
    new KeyValueModel(EnumTpStatusSessao.Fechada, "Fechada"),
    new KeyValueModel(EnumTpStatusSessao.Conferida, "Conferida"),
];